import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProvinceService } from '../services/province.service';
import {edit, CreateProvince} from '../Model/ProvinceModel';
import { ToastrService } from 'ngx-toastr';
declare var $: any;

@Component({
  selector: 'app-province',
  templateUrl: './province.component.html',
  styleUrls: ['./province.component.css']
})
export class ProvinceComponent implements OnInit {
  @Output() headerTitle = new EventEmitter<string>();
  CreateProvince: CreateProvince = new CreateProvince();
  currentSelected: any[];
  searchInput: any;
  departments: any;
  ProvinceData:Array<any>= new Array();
  editmodel:edit=new edit()
  isAdmin : boolean = false;
  role:any

  constructor(private provinceService: ProvinceService,private Toastr: ToastrService) { }

  ngOnInit() {
    this.CreateProvince.IsActive = true;
    this.headerTitle.emit("Province");
    this.role = localStorage.getItem("role");
    this.isAdmin = true;
    this.provinceService.getAllProvince().subscribe(data=>{
      this.ProvinceData = data;
    },
    error=>{
      this.Toastr.error("Something went on the server side !!!");
    });
  }

  create() {
    console.log('entered')
    this.provinceService.AddNewProvince(this.CreateProvince).subscribe((resp) => {
      if(resp == 'Province already exist'){
        this.Toastr.error(resp);
      }else{
        this.Toastr.success(resp);
      }
      this.ngOnInit();
      this.currentSelected = [];
      this.CreateProvince.ProvinceName='';
      this.CreateProvince.ProvinceCode='';
      this.searchInput.nativeElement.value = '';
      this.departments.nativeElement.value = '';
    },
      (error) => {
        this.Toastr.error("Something went on the server side !!!");
      });
  }
  Update(){
    this.provinceService.UpdateProvince(this.editmodel).subscribe(resp=>{
      this.Toastr.success('Province Updated Successfully ');
      $("#editDistrictModal").modal("hide");
      this.ngOnInit();
    },err=>{
    });

  } 

  SelectedProvinceDetail(data){
    this.editmodel = data;
  } 
}
